import { createContext, useCallback, useContext, useState } from 'react';

import { User } from '@models/User';

import { getUser } from '@services/UserService';

import { handleRequestError } from '@helpers/handleRequestError';

interface Context {
  user: User;
  loading: boolean;
  fetchUser: (username: string) => Promise<void>;
}

export const UserContext = createContext<Context>({} as Context);

export const UserProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async (username: string) => {
    try {
      setLoading(true);

      const response = await getUser(username);

      setUser(response);
    } catch (error) {
      handleRequestError('User not found');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, loading, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
